export default __webpack_public_path__ + "assets/media/Mid_Banner_MOB.f3dd4182.webp";